import axios from './axiosConfig'

export const getAllUser = async (page) => {
  const response = await axios.get(`/user?page=${page}`)

  console.log('users all: ', response.data)
  return response.data
}

export const getUserActivity = async (page) => {
  const response = await axios.get(`/user/activity?page=${page}`)

  console.log('user activity all: ', response.data)
  return response.data
}

export const blockUser = async (id) => {
  const response = await axios.put(`/user/${id}/block`)

  console.log('block user: ', response.data)
  return response.data
}

export const unblockUser = async (id) => {
  const response = await axios.put(`/user/${id}/unblock`)

  console.log('unblock user: ', response.data)
  return response.data
}

export const getInvoice = async (page) => {
  try {
    const response = await axios.get(`/report/invoice?page=${page}`)
    console.log('invoice res:', response.data)
    return response.data
  } catch (error) {
    throw new Error(
      error.response?.data || error.message || 'Failed to load Invoice'
    )
  }
}

export const getReport = async (page) => {
  try {
    const response = await axios.get(`/report/payment-status?page=${page}`)
    console.log('payment res:', response.data)
    return response.data
  } catch (error) {
    throw new Error(
      error.response?.data || error.message || 'Failed to load Payment'
    )
  }
}

export const getCartData = async () => {
  const response = await axios.get('/user/cart/data')
  console.log('cart data:', response.data)
  return response.data
}
